import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  Part,
  PartCreateRequest,
  PartListQuery,
  PartListResult,
  PartPatchRequest,
  PartUpdateRequest
} from '../models/part.model';

@Injectable({ providedIn: 'root' })
export class PartService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/parts`;

  getParts(query: PartListQuery = {}): Observable<PartListResult> {
    let params = new HttpParams();
    if (query.category) params = params.set('category', query.category);
    if (query.search) params = params.set('search', query.search);
    if (query.page) params = params.set('page', query.page);
    if (query.pageSize) params = params.set('pageSize', query.pageSize);

    return this.http.get<PartListResult>(this.baseUrl, { params });
  }

  getPartById(partId: number): Observable<Part> {
    return this.http.get<Part>(`${this.baseUrl}/${partId}`);
  }

  createPart(request: PartCreateRequest): Observable<Part> {
    return this.http.post<Part>(this.baseUrl, request);
  }

  updatePart(partId: number, request: PartUpdateRequest): Observable<Part> {
    return this.http.put<Part>(`${this.baseUrl}/${partId}`, request);
  }

  patchPart(partId: number, request: PartPatchRequest): Observable<Part> {
    return this.http.patch<Part>(`${this.baseUrl}/${partId}`, request);
  }

  deactivatePart(partId: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${partId}`);
  }
}
